"use client";

import {
  RUNTIME_OFFER_PLACEMENT_HI_MUHURAT_REPORT_BRIDGE,
  RUNTIME_OFFER_PLACEMENT_MUHURAT_REPORT_BRIDGE,
} from "@/lib/offer-placement-runtime-keys.generated";

import type { MuhuratResponse } from "@/lib/api/muhurat";
import type { PlaceResult } from "@ishvaram/ui/hooks";
import CalculatorReportBridge from "@/components/CalculatorReportBridge";
import {
  InauspiciousSlots,
  MuhuratSummaryBar,
  MuhuratTimeline,
  PanchangSummary,
} from "@/components/muhurat";

/**
 * Bundle-size discipline (2026-07-16 trim pass): the result renderers +
 * report bridge only paint AFTER the muhurat API responds, so they load as a
 * dynamic chunk from MuhuratClient (in parallel with the fetch) instead of
 * shipping in the route's initial JS. No layout change — the LoadingCard
 * spinner covers both the fetch and the chunk load (rule 58: never a 0px
 * collapse; the picker/header above stay mounted).
 */
export default function MuhuratResultsSection({
  result,
  selectedDate,
  selectedCity,
  shubhCount,
  ashubhCount,
  neutralCount,
  defaultLanguage,
}: {
  result: MuhuratResponse;
  selectedDate: string;
  selectedCity: PlaceResult | null;
  shubhCount: number;
  ashubhCount: number;
  neutralCount: number;
  defaultLanguage: "en" | "hi";
}) {
  const hi = defaultLanguage === "hi";
  const sourcePath = hi ? "/hi/muhurat" : "/muhurat";
  const bridgePlacement = hi
    ? RUNTIME_OFFER_PLACEMENT_HI_MUHURAT_REPORT_BRIDGE
    : RUNTIME_OFFER_PLACEMENT_MUHURAT_REPORT_BRIDGE;
  return (
    <div className="space-y-6">
      <InauspiciousSlots data={result} />
      <PanchangSummary data={result} />
      <MuhuratSummaryBar
        shubhCount={shubhCount}
        ashubhCount={ashubhCount}
        neutralCount={neutralCount}
      />
      <MuhuratTimeline
        slots={result.slots}
        selectedDate={selectedDate}
        selectedCity={selectedCity}
      />
      <CalculatorReportBridge
        planId="muhurat_report"
        source={sourcePath}
        intent="timing_muhurat"
        placement={bridgePlacement}
        title={hi ? "Personal Muhurat Report paayein" : "Get a personal Muhurat & Sankalp Plan"}
        body={
          hi
            ? "Yeh calculator city timing dikhata hai. Report me purpose, kundali, dasha pressure, avoid windows, sankalp aur ritual checklist milti hai."
            : "This calculator shows the city timing layer. The report adds your purpose, kundali, dasha pressure, avoid windows, sankalp, and ritual checklist."
        }
        cta={hi ? "Muhurat Report paayein" : "Get Muhurat Report"}
        language={defaultLanguage}
      />
    </div>
  );
}
